// src/services/dashboard/BookEnquiryManager.js

import axios from "axios";
import config from "../../config";

const BASE_URL = `${config.url}/api/book-enquiries`;

const BookEnquiryManager = {
  // Create a new book enquiry
  async createEnquiry(payload) {
    const response = await axios.post(`${BASE_URL}`, payload);
    return response.data;
  },

  // Get a single enquiry by ID
  async getEnquiryById(id) {
    const response = await axios.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  // Get all enquiries
  async getAllEnquiries() {
    const response = await axios.get(`${BASE_URL}`);
    return response.data;
  },

  // Delete enquiry by ID
  async deleteEnquiry(id) {
    const response = await axios.delete(`${BASE_URL}/${id}`);
    return response.data;
  },
};

export default BookEnquiryManager;
